import BasicText from "../../BasicText";
import LButton from "../../LButton";
import Subtitle from "../../Subtitle";
import Title from "../../Title";
import CrossThing from "../../svg/CrossThing";
import CrossThing2 from "../../svg/CrossThing2";
import LuminodeBlack from "../../svg/LuminodeBlack";
import LuminodeASCII from '@/assets/images/ASCII/Group 145.png'
import AsciiArt from "../../AsciiArt";
import HeroMainSpicy from "../../svg/HeroMainSpicy";
import DotEffect from "../../svg/DotEffect";
import CrossThingText from "../../svg/CrossThingText";
import MediumEllipse from "../../svg/ellipse/MediumEllipse";

function Hero({ref0}:any) {
  return (
    <div ref={ref0} className="flex flex-col justify-start items-start w-full xl:w-[1200px] px-4 sm:px-10 md:px-11 lg:px-12 xl:px-0 gap-[20px] relative pb-[40px] z-20">
      <Subtitle>
        // blockchain development
      </Subtitle>
      <Title light={false}>
        <div className="flex flex-col items-start">
          <div>
            Luminode is building  
          </div>
          <div>
            enterprise-grade
          </div>
          <div>
            solutions for the
          </div>
          <div className="relative h-[60px] w-[700px] mt-[5px]">
            <div className="absolute text-luminode-blue opacity-25 blur-[6px]">
               global onchain economy
            </div>
            <div className="absolute text-luminode-blue opacity-15 blur-[18px]">
               global onchain economy
            </div>
            <div className="absolute text-luminode-blue">
               global onchain economy
            </div>
          </div>
        </div>
      </Title>
      <BasicText color="faded">
        <div>Schedule a consultation today, so we can bring your vision to life.</div>
      </BasicText>
      <div className="flex flex-row gap-[16px] pt-[24px]">
        <LButton luminodeicon push_down>
          <div className="text-[16px]">Get in touch</div>
        </LButton>
        {/*        <div className="text-[#6A7380] border-[1.5px] border-[#22222F] bg-transparent py-[10px] px-[20px] uppercase font-semibold">see previous clients</div> */}
      </div>
      <div className="absolute right-[0px] hidden xl:block z-0">
        <AsciiArt src={LuminodeASCII} />
      </div>
      <div className="absolute top-[28px] right-[-27px] pointer-events-none">
        <HeroMainSpicy />
      </div>
      <div className="absolute top-[-80px] left-[256px] pointer-events-none">
        <DotEffect />
      </div>
      <div className="absolute top-[-57px] left-[-70px] pointer-events-none">
        <CrossThingText />
      </div>
      {/*<div className="absolute bottom-[30px] right-[420px]">
        <CrossThing2 />
  </div>*/}
    </div>
  );
}

export default Hero;